var timeAllow = 2999;
var timeReachLimit = false;
var startTime = performance.now();
var endTime = performance.now();
var timeProcess = 0;

class Timer {
	
	static start() {
		startTime = performance.now();
		timeReachLimit = false;
	}

	static stop() {
		endTime = performance.now();
		timeProcess = endTime - startTime;
		// timeReachLimit = false;
	}

	static setTimeBudget(timeBudget) {
		timeAllow = timeBudget;
	}

	static timeout(){
		if (timeReachLimit || performance.now() - startTime > timeAllow) {
			timeReachLimit = true;
		}
		return timeReachLimit;
	}

	static reachLimit(){
		return timeReachLimit;
	}

	static printTime(){
		return `Processing time ${endTime - startTime} ms`;
	}

	static stop_print() {
		Timer.stop();
		return Timer.printTime();
	}

	
	static stop_print2() {
		Timer.stop();
		return (endTime - startTime).toString();
	}

}
export default Timer;